import { type BadgeVariant } from '../../../components/ui/badgeVariants';
import type { RubriqueCategory } from '../payslipRubriques';

/**
 * Presentation mapping for payslip-line categories — expressed as *semantic*
 * variants (palette-free) so the colours live once in {@link BADGE_VARIANTS}.
 * The detail's legend, group markers and subtotals all read their colour from
 * here, matching the mockup: Gains green, employee charges red, employer charges
 * orange, STC blue, calculation white/blank (no highlight).
 */
export const RUBRIQUE_CATEGORY_VARIANT: Record<RubriqueCategory, BadgeVariant> = {
  gains: 'success',
  employeeCharges: 'error',
  employerCharges: 'warning',
  stc: 'primary',
  calculation: 'blank',
};

/** Category → i18n key under `payments:payslips.detail.categories`. */
export const RUBRIQUE_CATEGORY_LABEL_KEY: Record<RubriqueCategory, string> = {
  gains: 'gains',
  employeeCharges: 'employeeCharges',
  employerCharges: 'employerCharges',
  stc: 'stc',
  calculation: 'calculation',
};
